var _rect, _rect2, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint0_linear_5604_2688)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "url(#paint1_radial_5604_2688)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    fill: "url(#paint2_radial_5604_2688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5604_2688",
    x1: 0,
    y1: 0,
    x2: 23.5885,
    y2: 12.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8E6FF",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E6FF",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5604_2688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.243902 18.4615) rotate(-41.5346) scale(26.3923 71.1344)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5604_2688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.12195 14.2308) rotate(-41.5346) scale(13.1961 35.5672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentStep);
export default __webpack_public_path__ + "static/media/CurrentStep.6ec6cfcfe1c33ebbc6d597a4ae918a3f.svg";
export { ForwardRef as ReactComponent };